import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Title } from '@/components/Typography';
import { PercentageBar } from './PercentageBar';
import { GeneralInformationsResult } from '@/core/domain/owas-report';
import * as S from './styles';

interface GeneralInformationsProps {
	data: GeneralInformationsResult;
}

export function GeneralInformations({ data }: Readonly<GeneralInformationsProps>): JSX.Element {
	return (
		<Row>
			<Col span={24}>
				<Row gutter={[0, 10]}>
					<Col span={24}>
						<Title level={2}>General informations</Title>
					</Col>
					<Col span={24}>
						<S.Content justify="space-between">
							<S.InformationsContainer>
								<S.InformationInnerLeftContainer>
									<Title level={5} style={{ margin: 0 }}>
										Description of the activity
									</Title>
								</S.InformationInnerLeftContainer>
								<S.InformationInnerRightContainer>
									<p>{I18n.get(data.activity_description)}</p>
								</S.InformationInnerRightContainer>
							</S.InformationsContainer>
						</S.Content>
					</Col>
				</Row>
				<Row gutter={[0, 0]} style={{ marginTop: '2rem' }}>
					<Col span={5}>
						<S.Content justify="space-between" style={{ marginTop: '0.3rem' }}>
							<Title level={4}>Number of exposed</Title>
						</S.Content>
					</Col>
					<Col span={19}>
						<PercentageBar
							menExposed={data.men_exposed}
							womenExposed={data.women_exposed}
							otherExposed={data.other_exposed}
							percentages={data.percentages}
						/>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
